<template>
<!--  <div class="accordion" :class="{'opened': collapseOpened}">-->
<!--    <div class="resolution__doc__header cursor-pointer" @click="collapseOpened = !collapseOpened">-->
<!--      <div class="resolution__doc__header__left">-->
<!--        <svg viewBox="0 0 24 24" width="24" height="24">-->
<!--          <use xlink:href="@/assets/v2/img/sprite.svg#icon__folder"></use>-->
<!--        </svg>-->
<!--        <span class="resolution__doc__title">{{ resolution.title }}</span>-->
<!--        <span class="resolution__doc__status green__light">{{ resolution.statusText }}</span>-->
<!--      </div>-->
<!--      <div class="resolution__doc__header__right">-->
<!--        <button type="button">-->
<!--          <svg viewBox="0 0 24 24" width="24" height="24" class="accordion__arrow">-->
<!--            <use xlink:href="@/assets/v2/img/sprite.svg#chevron__down"></use>-->
<!--          </svg>-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="accordion&#45;&#45;collapse" :class="{'opened': collapseOpened}">-->
<!--      <div v-if="getResolutionTypeValueByKey('AGREEMENT') === resolution.type"-->
<!--           class="resolution__doc__curator">-->
<!--        <div class="resolution__doc__curator__label">{{ $lang.app.RESPONSIBLE }}:</div>-->
<!--        <div class="resolution__doc__curator__name">{{ responsibleFullName(resolution) }}</div>-->
<!--        <div class="resolution__doc__curator__role">{{ responsiblePosition(resolution) }}</div>-->
<!--      </div>-->
<!--      <div v-if="getResolutionTypeValueByKey('MAIN') === resolution.type"-->
<!--           class="resolution__doc__curator">-->
<!--        <div class="resolution__doc__curator__label">{{ $lang.app.CURATOR }}:</div>-->
<!--        <div class="resolution__doc__curator__name">{{ curatorFullName(resolution) }}</div>-->
<!--        <div class="resolution__doc__curator__role">{{ curatorPosition(resolution) }}</div>-->
<!--      </div>-->
<!--      <button type="button"-->
<!--              @click="$emitter.emit('open-employee-resolution-detail-modal', resolution)"-->
<!--              class="resolution&#45;&#45;open button button__icon&#45;&#45;right">-->
<!--        Сводная информация<svg class="icon" viewBox="0 0 24 24" width="24" height="24"><use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use></svg>-->
<!--      </button>-->
<!--      <ResolutionListAnswer v-if="resolutionStatusesGetValueByKey('FINISH') == resolution.status"-->
<!--                            :resolution="resolution" class="mb-8 mx-8"/>-->

<!--      <div class="resolution__cards">-->
<!--        <div class="row">-->
<!--          <div v-for="childResolution in resolution.children" :key="childResolution.id"-->
<!--               class="col-lg-4">-->
<!--            <div class=" resolution__card__item">-->
<!--              <div class="cursor-pointer mb-4" @click="$emitter.emit('open-employee-resolution-detail-modal', childResolution)">-->
<!--                <span class="resolution__doc__status green__light">{{ childResolution.statusText }}</span>-->
<!--                <span class="resolution__card__name">-->
<!--                          <span>{{ childResolution.title }}</span>-->
<!--                          <span v-if="hasDocNumber(childResolution)"-->
<!--                                class="ml-2 text-gray-500 text-sm"-->
<!--                                :title="$lang.app.NUMBER">({{ getDocNumber(childResolution) }})-->
<!--                          </span>-->
<!--                        </span>-->
<!--                <div class="resolution__doc__curator">-->
<!--                  <div class="resolution__doc__curator__label">{{ $lang.app.RESPONSIBLE }}:</div>-->
<!--                  <div class="resolution__doc__curator__name">{{ responsibleFullName(childResolution) }}</div>-->
<!--                  <div class="resolution__doc__curator__role">{{ responsiblePosition(childResolution) }}</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div v-if="resolutionStatusesGetValueByKey('FINISH') == childResolution.status"-->
<!--                   class="flex items-center mb-2">-->
<!--                <div class="p-2 rounded-full mr-2"-->
<!--                     :class="{-->
<!--                            'bg-green-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('POSITIVE'),-->
<!--                            'bg-orange-400': childResolution.lastAnswer.type === answerTypesGetValueByKey('REMARK'),-->
<!--                            'bg-red-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('NEGATIVE'),-->
<!--                          }"></div>-->
<!--                <p class="text-sm mr-2"-->
<!--                   :class="{-->
<!--                            'text-green-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('POSITIVE'),-->
<!--                            'text-orange-400': childResolution.lastAnswer.type === answerTypesGetValueByKey('REMARK'),-->
<!--                            'text-red-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('NEGATIVE'),-->
<!--                          }">-->
<!--                  {{ $lang.app[answerTypesGetLabelRefByValue(childResolution.lastAnswer.type)] }}-->
<!--                </p>-->
<!--              </div>-->
<!--              <ResolutionListAnswer v-if="resolutionStatusesGetValueByKey('FINISH') == childResolution.status"-->
<!--                                    :resolution="childResolution"/>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

  <div v-if="getResolutionTypeValueByKey('AGREEMENT') === resolution.type"
       class="resolution__item" :class="{'resolution--active': $route.params.resolutionId == resolution.id}">
    <router-link class="no-underline" :to="{
        name: 'EmployeeApplicationResolution',
        params: {
          applicationId: $route.params.applicationId,
          resolutionId: resolution.id
        }
      }">
      <div class="resolution__doc__header">
        <div class="resolution__doc__header__left">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#icon__folder"></use>
          </svg>
          <span class="resolution__doc__title">{{ resolution.title }}</span>

        </div>
        <div class="resolution__doc__header__right">
          <span class="resolution__doc__status green__light">{{ resolution.statusText }}</span>
        </div>
      </div>
      <div class="resolution__doc__curator">
        <div class="resolution__doc__curator__label">{{ $lang.app.RESPONSIBLE }}:</div>
        <div class="resolution__doc__curator__name">{{ responsibleFullName(resolution) }}</div>
        <div class="resolution__doc__curator__role">{{ responsiblePosition(resolution) }}</div>
      </div>
    </router-link>
    <ResolutionListAnswer v-if="resolutionStatusesGetValueByKey('FINISH') == resolution.status"
                          :resolution="resolution" class="mb-8 mx-8"/>
    <div class="resolution__cards pb-2">
      <div v-for="childResolution in resolution.children" :key="childResolution.id" class="resolution__card__item">
        <router-link class="no-underline block mb-3" :to="{
        name: 'EmployeeApplicationResolution',
        params: {
          applicationId: $route.params.applicationId,
          resolutionId: childResolution.id
        }
      }" >
          <span class="resolution__doc__status green__light">{{ childResolution.statusText }}</span>
          <span class="resolution__card__name">{{ childResolution.title }}</span>
          <div class="resolution__doc__curator">
            <div class="resolution__doc__curator__label">{{ $lang.app.RESPONSIBLE }}:</div>
            <div class="resolution__doc__curator__name">{{ responsibleFullName(childResolution) }}</div>
            <div class="resolution__doc__curator__role">{{ responsiblePosition(childResolution) }}</div>
          </div>
        </router-link>
        <div v-if="resolutionStatusesGetValueByKey('FINISH') == childResolution.status"
             class="flex items-center mb-2">
          <div class="p-2 rounded-full mr-2"
               :class="{
                            'bg-green-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('POSITIVE'),
                            'bg-orange-400': childResolution.lastAnswer.type === answerTypesGetValueByKey('REMARK'),
                            'bg-red-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('NEGATIVE'),
                          }"></div>
          <p class="text-sm mr-2"
             :class="{
                            'text-green-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('POSITIVE'),
                            'text-orange-400': childResolution.lastAnswer.type === answerTypesGetValueByKey('REMARK'),
                            'text-red-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('NEGATIVE'),
                          }">
            {{ $lang.app[answerTypesGetLabelRefByValue(childResolution.lastAnswer.type)] }}
          </p>
        </div>
        <ResolutionListAnswer v-if="resolutionStatusesGetValueByKey('FINISH') == childResolution.status"
                              :resolution="childResolution"/>
      </div>
    </div>
  </div>
  <div v-if="getResolutionTypeValueByKey('MAIN') === resolution.type"
       class="resolution__item" :class="{'resolution--active': $route.params.resolutionId == resolution.id}">
    <router-link class="no-underline" :to="{
        name: 'EmployeeApplicationResolution',
        params: {
          applicationId: $route.params.applicationId,
          resolutionId: resolution.id
        }
      }">
      <div class="resolution__doc__header">
        <div class="resolution__doc__header__left">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#icon__folder"></use>
          </svg>
          <span class="resolution__doc__title">{{ resolution.title }}</span>

        </div>
        <div class="resolution__doc__header__right">
          <span class="resolution__doc__status green__light">{{ resolution.statusText }}</span>
          <span class="ml-4 resolution__doc__status orange__medium">
            {{ resolution.paymentStatus ? $lang.app[paymentStatusesLRBV(resolution.paymentStatus)] : $lang.app.PAYMENT_NOT_CALCULATED_YET }}</span>
        </div>
      </div>
      <div class="resolution__doc__curator">
        <div class="resolution__doc__curator__label">{{ $lang.app.CURATOR }}:</div>
        <div class="resolution__doc__curator__name">{{ curatorFullName(resolution) }}</div>
        <div class="resolution__doc__curator__role">{{ curatorPosition(resolution) }}</div>
      </div>
    </router-link>
    <ResolutionListAnswer v-if="resolutionStatusesGetValueByKey('FINISH') == resolution.status"
                          :resolution="resolution" class="mb-8 mx-8"/>
    <div class="resolution__cards pb-2">
      <div v-for="childResolution in resolution.children" :key="childResolution.id" class="resolution__card__item">
        <router-link class="no-underline block mb-3" :to="{
        name: 'EmployeeApplicationResolution',
        params: {
          applicationId: $route.params.applicationId,
          resolutionId: childResolution.id
        }
      }">
          <div class="flex items-center">
            <span class="resolution__doc__status green__light">{{ childResolution.statusText }}</span>
            <span class="ml-4 resolution__doc__status orange__medium">
            {{ childResolution.paymentStatus ? $lang.app[paymentStatusesLRBV(childResolution.paymentStatus)] : $lang.app.PAYMENT_NOT_CALCULATED_YET }}</span>
          </div>
          <span class="resolution__card__name">{{ childResolution.title }}</span>
          <div class="resolution__doc__curator">
            <div class="resolution__doc__curator__label">{{ $lang.app.RESPONSIBLE }}:</div>
            <div class="resolution__doc__curator__name">{{ responsibleFullName(childResolution) }}</div>
            <div class="resolution__doc__curator__role">{{ responsiblePosition(childResolution) }}</div>
          </div>
        </router-link>
        <div v-if="resolutionStatusesGetValueByKey('FINISH') == childResolution.status"
             class="flex items-center mb-2">
          <div class="p-2 rounded-full mr-2"
               :class="{
                            'bg-green-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('POSITIVE'),
                            'bg-orange-400': childResolution.lastAnswer.type === answerTypesGetValueByKey('REMARK'),
                            'bg-red-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('NEGATIVE'),
                          }"></div>
          <p class="text-sm mr-2"
             :class="{
                            'text-green-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('POSITIVE'),
                            'text-orange-400': childResolution.lastAnswer.type === answerTypesGetValueByKey('REMARK'),
                            'text-red-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('NEGATIVE'),
                          }">
            {{ $lang.app[answerTypesGetLabelRefByValue(childResolution.lastAnswer.type)] }}
          </p>
        </div>
        <ResolutionListAnswer v-if="resolutionStatusesGetValueByKey('FINISH') == childResolution.status"
                              :resolution="childResolution"/>
      </div>
    </div>
  </div>
</template>
<script>
import { getValueByKey as getResolutionTypeValueByKey} from "../../../../helpers/constants/resolutionTypes";
import ResolutionListAnswer from "../../../../components/employee/application/resolution/ResolutionListAnswer";
import {getValueByKey as resolutionStatusesGetValueByKey} from "../../../../helpers/constants/resolutionStatuses";
import {
  getLabelRefByValue as answerTypesGetLabelRefByValue,
  getValueByKey as answerTypesGetValueByKey,
} from "../../../../helpers/constants/answerTypes";
import {getLabelRefByValue as paymentStatusesLRBV} from "../../../../helpers/constants/paymentStatuses";

export default {
  props: {
    resolution: Object,
  },
  components: {
    ResolutionListAnswer
  },
  data() {
    return {
      collapseOpened: false,
    }
  },
  methods: {
    getResolutionTypeValueByKey,
    resolutionStatusesGetValueByKey,
    answerTypesGetLabelRefByValue,
    answerTypesGetValueByKey,
    paymentStatusesLRBV,
    hasDocNumber(resolution) {
      return resolution.additionalAgreement?.number
    },
    getDocNumber(resolution) {
      return resolution.additionalAgreement?.agreement?.number + '/' + resolution.additionalAgreement.number
    },
    responsiblePosition(resolution) {
      let responsible = resolution.executors.find(e => e.responsible)
      return this.executorPosition(responsible)
    },
    responsibleFullName(resolution) {
      return resolution.executors.find(e => e.responsible)?.employment.fullName
    },
    curatorPosition(resolution) {
      let responsible = resolution.executors.find(e => e.curator)
      return this.executorPosition(responsible)
    },
    curatorFullName(resolution) {
      return resolution.executors.find(e => e.curator)?.employment.fullName
    },
    executorPosition(executor) {
      if(executor) {
        return this.$lang.$translate({
              ru: executor.employment.position.nameRu,
              kg: executor.employment.position.nameKg
            }) + ' | ' +
            this.$lang.$translate({
              ru: executor.employment.position.department.nameRu,
              kg: executor.employment.position.department.nameKg
            })
      }
      return '-'
    }
  }
}
</script>